module.exports = __webpack_public_path__ + "static/img/avatar_r_11.00198c62.png";